import { createI18n } from 'vue-i18n';

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import nl from './locales/nl.json';

const userAgentLocale = window.navigator.language.substring(0, 2);
const savedLocale = window.localStorage.getItem('locale');
const locale = savedLocale || userAgentLocale || 'nl';

export default createI18n({
   legacy: false,
   locale,
   fallbackLocale: 'nl',
   messages: { nl, en, fr, de },
   globalInjection: true,
   fallbackWarn: false,
   allowComposition: true,
});
